<style lang="scss" scoped>
.vue-dropzone {
    border: 1px solid #e3eaee;
}
</style>

<template>
    <div>
        <vue-dropzone ref="dropzone" id="dropzone" class="mb-30 d-flex flex-wrap" v-on:vdropzone-thumbnail="fileAdded" v-on:vdropzone-error="fileError" v-on:vdropzone-removed-file="error = ''" :options="dropzoneOptions"></vue-dropzone>
        <span v-if="error" class="text-danger fs-14">{{ error }}</span>

        <div v-if="!uploading" class="btn btn-primary" @click="uploadFiles()">Upload</div>
        <loader v-if="uploading"></loader>
    </div>
</template>

<script>
import VueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapActions } from "vuex";
import Loader from "@/components/global/loader";

export default {
    components: { VueDropzone, Loader },
    props: {
        /**
         * Shipment object
         * @type {Object}
         */
        shipment: {
            type: Object,
            default: () => {
                return {};
            }
        },

        /**
         * Shipment object
         * @type {Object}
         */
        imageOnly: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            error: "",
            dropzoneOptions: {
                autoProcessQueue: false,
                url: "/",
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                maxFilesize: 5,
                maxFiles: 5,
                addRemoveLinks: true,
                duplicateCheck: true,
                headers: {},
                dictDefaultMessage: this.$t('bin.dropzone.selectfile'),
                dictFileTooBig: this.$t('bin.dropzone.filetoobig'),
                dictInvalidFileType: this.$t('bin.dropzone.invalidfiletype'),
                dictRemoveFile: this.$t('bin.dropzone.delete'),
                acceptedFiles: `.jpg,.jpeg,.png,.bmp${
                    this.imageOnly ? "" : ",.pdf"
                }`
            },
            uploading: false
        };
    },
    methods: {
        ...mapActions(["uploadAttachment"]),
        fileAdded(file) {
            this.$emit("added");
        },
        fileError(file, message, xhr) {
            this.error = message;
        },
        uploadFiles() {
            if (!this.uploading) {
                this.uploading = true;
                this.uploadAttachment({
                    content: {
                        object: "shipment",
                        object_id: this.shipment.id,
                        attachments: []
                    },
                    type: "cmr",
                    attachments: this.$refs.dropzone.getAcceptedFiles()
                })
                    .then(resp => {
                        this.uploading = false;
                        console.log(this.$refs.dropzone);
                        this.$emit("uploaded");
                        this.$refs.dropzone.removeAllFiles();
                        console.log(resp);
                    })
                    .catch(err => {
                        this.uploading = false;
                        console.log(err);
                    });            
            }
        }
    },

    computed: {}
};
</script>
